import { render, staticRenderFns } from "./copy-declare-customs.vue?vue&type=template&id=8c27acd8&scoped=true"
import script from "./copy-declare-customs.vue?vue&type=script&lang=ts"
export * from "./copy-declare-customs.vue?vue&type=script&lang=ts"
import style0 from "./copy-declare-customs.vue?vue&type=style&index=0&id=8c27acd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c27acd8",
  null
  
)

export default component.exports